import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { findTableColumnDefinitionByPreferenceKey } from "helpers/GeneralHelper";

export const getColumnExportHeaderLabel = (col = {}) => {
    if (col?.exportHeader != null && String(col.exportHeader).trim() !== "") {
        return String(col.exportHeader).trim();
    }
    if (col?.keyName != null && String(col.keyName).trim() !== "") {
        return String(col.keyName).trim();
    }
    return String(col?.Header ?? col?.accessor ?? "").trim();
};

export const getVisibleReportTableColumns = (columns = [], visibleColumnOrder = []) =>
    (Array.isArray(visibleColumnOrder) ? visibleColumnOrder : [])
        .map((preferenceKey) =>
            findTableColumnDefinitionByPreferenceKey(columns, preferenceKey)
        )
        .filter(Boolean);

export const copyReportTableToClipboard = async ({
    visibleColumns = [],
    rows = [],
}) => {
    const headers = visibleColumns.map(getColumnExportHeaderLabel).join("\t");
    const normalizedRows = rows
        .map((row) =>
            row.map((value) => (value == null ? "" : String(value))).join("\t")
        )
        .join("\n");

    await navigator.clipboard.writeText(`${headers}\n${normalizedRows}`);
};

export const exportReportTableToCsv = ({
    pageName = "Report",
    visibleColumns = [],
    rows = [],
}) => {
    const headers = visibleColumns.map(getColumnExportHeaderLabel);
    const normalizedRows = rows.map((row) =>
        row.map((value) => (value == null ? "" : String(value)))
    );

    const csvContent = [headers, ...normalizedRows]
        .map((cells) =>
            cells.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(",")
        )
        .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${pageName}  - (DEV) Ancile Hiring Tools.csv`;
    link.click();
};

export const exportReportTableToExcel = ({
    pageName = "Report",
    visibleColumns = [],
    rows = [],
}) => {
    const headers = visibleColumns.map(getColumnExportHeaderLabel);
    const normalizedRows = rows.map((row) =>
        row.map((value) => (value == null ? "" : String(value)))
    );

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...normalizedRows]);
    worksheet["!cols"] = headers.map((headerLabel) => {
        const normalizedHeader = String(headerLabel).toLowerCase();
        if (normalizedHeader === "sn" || normalizedHeader === "id") return { wch: 8 };
        return { wch: 24 };
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, `${pageName}  - (DEV) Ancile Hiring Tools.xlsx`);
};

export const exportReportTableToPdf = ({
    pageName = "Report",
    visibleColumns = [],
    rows = [],
}) => {
    const doc = new jsPDF("l", "pt", "a4");
    const headers = visibleColumns.map(getColumnExportHeaderLabel);

    autoTable(doc, {
        head: [headers],
        body: rows,
        startY: 40,
        theme: "striped",
        styles: {
            fontSize: 9,
            cellPadding: { top: 6, right: 6, bottom: 6, left: 6 },
            textColor: "#000",
            lineColor: "#e5e7eb",
            lineWidth: 0.5,
            valign: "middle",
            halign: "left",
        },
        headStyles: {
            fillColor: "#2f3e4e",
            textColor: "#ffffff",
            fontStyle: "bold",
            fontSize: 10,
            halign: "left",
            valign: "middle",
        },
        alternateRowStyles: {
            fillColor: "#f3f4f6",
        },
        bodyStyles: {
            fillColor: "#ffffff",
        },
        didParseCell: (data) => {
            data.cell.styles.cellWidth = "wrap";
        },
        margin: { left: 20, right: 20 },
    });

    doc.save(`${pageName}  - (DEV) Ancile Hiring Tools.pdf`);
};
